export default {
  SET_AUTH: 'SET_AUTH',
  SET_INITIAL_CONFIGURATION: 'SET_INITIAL_CONFIGURATION',
  SET_USER_DATA: 'SET_USER_DATA',
  SET_BETGAMES_IFRAME_URL_DATA: 'SET_BETGAMES_IFRAME_URL_DATA',
  SET_IS_APPLICATION_LOADED: 'SET_IS_APPLICATION_LOADED',
  SET_LOADING: 'SET_LOADING',
};
